import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

/** THE LEGACY RSA DEVICE SIGNATURE, TO BE REMOVED ONCE DB IS STABLE*/ 
declare function encode_deviceprint(): any;

@Injectable({
  providedIn: 'root'
})
export class DeviceprintService {
  private readonly DEFAULT_BROADCOM_RISK: string = "IARISK";
  /**Due to issues with the current broadcom risk engine, we need to include both device signatures for the time being, in case we want to make tenant level risk provider change */
  private readonly _RISK_SIGNATURE_LEGACY_MODE: boolean = true;
  private fingerPrintDna_IARiskSDK: string;
  private fingerPrintDna_RSARiskSDK: string;
  
  public riskType: string;
  public fingerPrintSource: Subject<string> = new Subject<string>();

  get RISK_SIGNATURE_LEGACY_MODE(): boolean {
    return this._RISK_SIGNATURE_LEGACY_MODE;
  }
  
  constructor() { }

  /**
   * Use Broadcom Risk Engine as default In the future, only IARISK will be supported.
   * Set default to IARISK
   */
  public setRiskEngineTypeIARisk() {
    this.riskType = this.DEFAULT_BROADCOM_RISK;

    // Propagate risk type
    localStorage.setItem("riskType", this.riskType);

    // Generate device fingerprint for risk type
    this.setDevicePrint();
  }

  /**
   * Set the device print according to the risk type
   */
  private setDevicePrint(): any {
    this.fingerPrintDna_IARiskSDK = this.getIARiskFingerprintFromSDK();

    if(this._RISK_SIGNATURE_LEGACY_MODE) {
      this.fingerPrintDna_RSARiskSDK = this.getRSARiskFingerprintFromSDK();
    }
  }

  private getIARiskFingerprintFromSDK(): string {
    let fingerprint: string = "";

    // If something went wrong with JS, output to console
    if(window["IaDfp"]) {
      fingerprint = window["IaDfp"].readFingerprint();
    }
    else {
      console.error("Something went wrong loading IARisk SDK...This is critical")
    }
    return fingerprint;
  }

  private getRSARiskFingerprintFromSDK(): string{
    let fingerprint: string = "";
    fingerprint = encode_deviceprint();

    return fingerprint;
  }

  /**
   * If deviceID is present in broadcoms authenticate response, then this means the device is unknown.
   * Need to update the tag so it is remembered and write this to the browser so we can use it later.
   */
  public configureNewDeviceIDSignature(deviceID: string): void {
    if (deviceID != null) {
      window["IaDfp"].writeTag(deviceID, true);
      this.fingerPrintDna_IARiskSDK = window["IaDfp"].readFingerprint();
    }  
  }

  public getIARiskDeviceTagSignature(): string {
    return this.fingerPrintDna_IARiskSDK;
  }

  public getRSARiskDeviceTagSignature(): string {
    return this.fingerPrintDna_RSARiskSDK;
  }
}